import {useEffect, useRef} from 'react';
// @ts-ignore
import {Link} from 'react-router-dom';
// @ts-ignore
import {observer} from 'mobx-react';
// @ts-ignore
import useCustomers from 'src/hooks/use-customers';
import RoundButton from 'src/components/roundButton';
import I18nMessage from 'src/components/I18nMessage';
import useStore from 'src/hooks/use-store';
import useAlerts from 'src/hooks/use-alerts';
import {useCompanyConfigurations} from './queries';
import {useCompanyConfigState} from './hooks';
import CompanyConfigProvider from './provider';
import CompanyListView from './list';
import CompanyFormView from './form';
import {buildCompanyRows, Central} from './rows';

const CompanyAdminLayoutContent = () => {
  const {store} = useStore();
  const {theme} = store;
  const {activeView} = useCompanyConfigState();
  const {data: configurations, isLoading, isError, error} = useCompanyConfigurations();
  const {customers: customerStore} = useCustomers();
  const {toast} = useAlerts();

  // customerStore.list returns a fresh array on every read (toJS), so memoizing would never hit.
  const centrals: Central[] = customerStore.list
    .filter((customer: {category: string}) => customer.category === 'monitoring')
    .map((customer: {id: number; name: string}) => ({id: customer.id, name: customer.name}));

  // useAlerts returns a fresh object on every render, so the effect is keyed on
  // the error itself to avoid one toast per retry.
  const toastedError = useRef<unknown>(null);

  useEffect(() => {
    if (!isError || toastedError.current === error) return;
    toastedError.current = error;
    const apiError = error as { data?: string; status?: number };
    toast.errorStatus({data: apiError?.data, status: apiError?.status ?? 500});
  }, [isError, error, toast]);

  const headerName = {
    list: 'sharedCompany',
    create: 'sharedCreateNew',
    edit: 'sharedEdit',
    my_company: 'sharedMyCompany',
  }[activeView];

  const views = {
    list: (
      <CompanyListView
        loading={isLoading}
        companies={buildCompanyRows(configurations ?? [], centrals)}
      />
    ),
    create: <CompanyFormView centrals={centrals} />,
    edit: <CompanyFormView centrals={centrals} />,
    my_company: <CompanyFormView centrals={centrals} />,
  };

  return (
    <div>
      <div>
        <div className="float-left">
          <h2 style={{color: theme}} className="form-title">
            <I18nMessage id={headerName} />
          </h2>
        </div>
        {/* @ts-ignore */}
        <RoundButton className="mt-3 mb-3 float-right" tag={Link} to="/admin">
          <span className="fas fa-times text-secondary" />
        </RoundButton>
        <div className="clearfix">&nbsp;</div>
      </div>
      {views[activeView]}
    </div>
  );
};

// The customer list comes from the MobX store, which loads after the first render.
const ObservedCompanyAdminLayoutContent = observer(CompanyAdminLayoutContent);

const CompanyAdminLayout = () => {
  return (
    <CompanyConfigProvider>
      <ObservedCompanyAdminLayoutContent />
    </CompanyConfigProvider>
  );
};

export default CompanyAdminLayout;
